import React from "react";
import { NumberPicker } from "../../../shared/components/NumberPicker";

function MarketListDefaultItem({ item }) {
    return (
        <div className="d-flex align-items-center gap-3 position-relative py-1">
            <div className="d-flex flex-column flex-grow-1">
                <span>{item.product_name}</span>
            </div>
            <NumberPicker defaultValue={item.quantity} />
        </div>
    );
}

export default MarketListDefaultItem;
